<h1 mat-dialog-title>{{ 'cookies.preferencesTitle' | t }}</h1>
<mat-dialog-content class="mat-typography">
  <p class="intro">{{ 'cookies.preferencesIntro' | t }}</p>

  <section class="purpose">
    <mat-slide-toggle [checked]="true" [disabled]="true"><span class="purpose-title">{{ 'cookies.necessary' | t }}</span></mat-slide-toggle>
    <p>{{ 'cookies.necessaryText' | t }}</p>
  </section>

  <section class="purpose">
    <mat-slide-toggle [(ngModel)]="data.analytics"><span class="purpose-title">{{ 'cookies.analytics' | t }}</span></mat-slide-toggle>
    <p>{{ 'cookies.analyticsText' | t }}</p>
  </section>

  <section class="purpose">
    <mat-slide-toggle [(ngModel)]="data.ads"><span class="purpose-title">{{ 'cookies.ads' | t }}</span></mat-slide-toggle>
    <p>{{ 'cookies.adsText' | t }}</p>
  </section>

  <p class="hint">{{ 'cookies.changeLater' | t }} <a routerLink="/cookies" mat-dialog-close>{{ 'cookies.policyLink' | t }}</a></p>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <button mat-stroked-button type="button" (click)="rejectAll()">{{ 'cookies.rejectAll' | t }}</button>
  <button mat-stroked-button type="button" (click)="save()">{{ 'cookies.saveChoices' | t }}</button>
  <button mat-stroked-button type="button" (click)="acceptAll()">{{ 'cookies.acceptAll' | t }}</button>
</mat-dialog-actions>
